import { printf, toText } from "./fable_modules/fable-library-js.4.24.0/String.js";
import { createElement } from "react";
import { createObj } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { ShieldLockRegular, WeatherSunnyLowRegular } from "@fluentui/react-icons";
import { Display, Caption1, tokens } from "@fluentui/react-components";
import { reactApi } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { ofArray } from "./fable_modules/fable-library-js.4.24.0/List.js";

/**
 * Takes a string that is directly injected into the DOM
 */
export function injectCss(css) {
    const style = document.createElement("style");
    style.innerText = css;
    document.head.appendChild(style);
}

/**
 * Takes an int and generates a deterministic color
 */
export function intToColor(input) {
    const r = ((input * 123) % 256) | 0;
    const g = ((input * 321) % 256) | 0;
    const b = ((input * 213) % 256) | 0;
    return toText(printf("#%02X%02X%02X"))(r)(g)(b);
}

export function dataFetchFailedView() {
    let elems, el, el_2;
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    }], (elems = [(el = WeatherSunnyLowRegular, createElement(el, {
        primaryFill: tokens.colorBrandForeground1,
        style: {
            fontSize: 96 + "px",
        },
    })), (el_2 = Caption1, createElement(el_2, {
        children: "Noe gikk galt, klarte ikke å hente data",
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function unauthorizedView() {
    let elems, el, el_2;
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    }], (elems = [(el = ShieldLockRegular, createElement(el, {
        primaryFill: tokens.colorBrandForeground1,
        style: {
            fontSize: 96 + "px",
        },
    })), (el_2 = Caption1, createElement(el_2, {
        children: "Du har ikke de nødvendige tilgangene for dette innholdet",
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function notFoundView() {
    let elems, el, el_2;
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    }], (elems = [(el = Display, createElement(el, {
        children: "404",
    })), (el_2 = Caption1, createElement(el_2, {
        children: "Siden du lette etter finnes ikke",
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

//# sourceMappingURL=Helpers.jsx.map
